/**
 * 推广链接码的本机暂存:打开 /r/:code 时记下,注册时带上(首次绑定归属);30 天有效,注册成功即清掉。
 * 只存在本机浏览器;存储不可用(隐私模式)时静默跳过。
 */
const KEY = 'cg.ref';
const TTL_MS = 30 * 86400_000;

export interface RefInfo {
  code: string;
  orgName: string;
}

export function saveRef(code: string, orgName = ''): void {
  try {
    localStorage.setItem(KEY, JSON.stringify({ code, orgName, at: Date.now() }));
  } catch {
    /* 隐私模式等 */
  }
}

export function readRefInfo(): RefInfo | undefined {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return undefined;
    const v = JSON.parse(raw) as { code?: string; orgName?: string; at?: number };
    if (!v.code || !v.at || Date.now() - v.at > TTL_MS) {
      localStorage.removeItem(KEY);
      return undefined;
    }
    return { code: v.code, orgName: v.orgName ?? '' };
  } catch {
    return undefined;
  }
}

export function readRef(): string | undefined {
  return readRefInfo()?.code;
}

export function clearRef(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
